import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/components/Layout/Layout.vue'
import pageLayout from '../views/pageLayout/layout.vue'
Vue.use(VueRouter)

const routes = [{
		path: '/Login',
		name: 'Login',
		component: () => import('@/views/Login/Login.vue')
	},
	{
		path: '/Forget',
		name: 'Forget',
		component: () => import('@/views/Login/Forget.vue')
	},
	{
		path: '/',
		redirect: 'Home',
		component: Layout,
		meta: {
			auth: true
		},
		children: [{
				path: 'Home',
				name: 'Home',
				component: pageLayout,
				redirect: 'Home/home',
				meta: {
					title: '首页',
					auth: true
				},
				children: [{
					path: 'home',
					name: 'home',
					component: () => import('@/views/Home/home.vue'),
					meta: {
						auth: true
					},
				}]
			},
			{
				path: 'message',
				name: 'message',
				component: () => import('@/views/Home/message.vue'),
				meta: {
					auth: true
				},
			},
			{
				path: 'forgetPass',
				name: 'forgetPass',
				component: () => import('@/views/Home/forgetPass.vue'),
				meta: {
					auth: true
				},
			},
			{
				path: 'item_store',
				name: 'item_store',
				component: pageLayout,
				redirect: 'item_store/index',
				meta: {
					title: '企业产品',
					auth: true
				},
				children: [{
						path: 'index',
						name: 'item_store_index',
						component: () => import('@/views/item_store/item_store.vue'),
						meta: {
							auth: true
						}
					},
					{
						path: 'publish_item',
						name: 'publish_item',
						component: () => import('@/views/item_store/publish_item.vue'),
						meta: {
							title: '发布产品',
							auth: true
						}
					},
					{
						path: 'publish_serve',
						name: 'publish_serve',
						component: () => import('@/views/item_store/publish_item1.vue'),
						meta: {
							title: '发布产品/服务',
							auth: true
						}
					},
					{
						path: 'ad_agreement',
						name: 'ad_agreement',
						component: () => import('@/views/item_store/ad_agreement.vue'),
						meta: {
							title: '广告法',
							auth: true
						}
					},
					{
						path: 'edit_item',
						name: 'edit_item',
						component: () => import('@/views/item_store/edit_item.vue'),
						meta: {
							title: '编辑商品',
							auth: true
						}
					},
					{
						path: 'add_optional',
						name: 'add_optional',
						component: () => import('@/views/item_store/add_optional.vue'),
						meta: {
							title: '添加选配商品',
							auth: true
						}
					},
					{
						path: 'show_optional/:id',
						name: 'show_optional',
						component: () => import('@/views/item_store/show_optional.vue'),
						meta: {
							title: '查看选配商品',
							auth: true
						}
					},
					{
						path: 'edit_optional/:id',
						name: 'edit_optional',
						component: () => import('@/views/item_store/edit_optional.vue'),
						meta: {
							title: '编辑选配商品',
							auth: true
						}
					}
				]
			},
			{
				path: 'distributors',
				name: 'distributors',
				component: pageLayout,
				redirect: 'distributors/index',
				meta: {
					title: '分销商',
					auth: true
				},
				children: [{
					path: 'index',
					name: 'distributor_index',
					component: () => import('@/views/distributors/distributors.vue'),
					meta: {
						auth: true
					}
				}, {
					path: 'company_detail/:id',
					name: 'company_detail',
					component: () => import('@/views/distributors/company_detail.vue'),
					meta: {
						title: '省分公司',
						auth: true
					}
				},{
					path: 'city_companyDetail/:id',
					name: 'city_companyDetail',
					component: () => import('@/views/distributors/city_companyDetail.vue'),
					meta: {
						title: '市分公司',
						auth: true
					}
				}, {
					path: 'shop_detail/:id',
					name: 'shop_detail',
					component: () => import('@/views/distributors/shop_detail.vue'),
					meta: {
						title: '店铺',
						auth: true
					}
				}, {
					path: 'more_detail/:id',
					name: 'more_detail',
					component: () => import('@/views/distributors/more_detail.vue'),
					meta: {
						title: '分销商详情',
						auth: true
					}
				}, {
					path: 'auditEdit/:id',
					name: 'auditEdit',
					component: () => import('@/views/distributors/auditEdit.vue'),
					meta: {
						title: '品牌审核',
						auth: true
					}
				}, {
					path: 'branch',
					name: 'branch',
					component: () => import('@/views/distributors/branch.vue'),
					meta: {
						title: '下级分公司',
						auth: true
					}
				},{
					path: 'sale_data',
					name: 'sale_data',
					component: () => import('@/views/distributors/sale_data.vue'),
					meta: {
						title: '门店数据排行',
						auth: true
					}
				}, {
					path: 'add_distributors',
					name: 'add_distributors',
					component: () => import('@/views/distributors/add_distributors.vue'),
					meta: {
						title: '添加分销商',
						auth: true
					}
				},{
					path: 'distributor_goods/:id',
					name: 'distributor_goods',
					component: () => import('@/views/distributors/distributor_goods.vue'),
					meta: {
						title: '分销商品概况',
						auth: true
					}
				},{
					path: 'branch_office/:id',
					name: 'branch_office',
					component: () => import('@/views/distributors/branch_office.vue'),
					meta: {
						title: '分公司概况',
						auth: true
					}
				},{
					path: 'branch_shop/:id',
					name: 'branch_shop',
					component: () => import('@/views/distributors/branch_shop.vue'),
					meta: {
						title: '分公司门店概况',
						auth: true
					}
				},{
					path: 'subordinate_branch/:id',
					name: 'subordinate_branch',
					component: () => import('@/views/distributors/subordinate_branch.vue'),
					meta: {
						title: '下级分公司',
						auth: true
					}
				},{
					path: 'subordinate_store/:id',
					name: 'subordinate_store',
					component: () => import('@/views/distributors/subordinate_store.vue'),
					meta: {
						title: '下级门店',
						auth: true
					}
				},{
					path: 'shopgoods_mesage/:id',
					name: 'shopgoods_mesage',
					component: () => import('@/views/distributors/shopgoods_mesage.vue'),
					meta: {
						title: '直营店',
						auth: true
					}
				},{
					path: 'shopbuy_message/:id',
					name: 'shopbuy_message',
					component: () => import('@/views/distributors/shopbuy_message.vue'),
					meta: {
						title: '直营店',
						auth: true
					}
				}, {
					path: 'import_success',
					name: 'import_success',
					component: () => import('@/views/distributors/import_success.vue'),
					meta: {
						title: '导入成功',
						auth: true
					}
				}]
			},
			{
				path: 'table',
				name: 'table',
				component: pageLayout,
				redirect: 'table/index',
				meta: {
					title: '报表',
					auth: true
				},
				children: [{
						path: 'index',
						name: 'table_index',
						component: () => import('@/views/table/index.vue'),
						meta: {
							auth: true
						},
					},
					{
						path: 'sale_rank',
						name: 'sale_rank',
						component: () => import('@/views/table/sale_rank.vue'),
						meta: {
							title: '销售排行',
							auth: true
						},
					},
					{
						path: 'data_rank',
						name: 'data_rank',
						component: () => import('@/views/table/data_rank.vue'),
						meta: {
							title: '数据排行',
							auth: true
						}
					},
					{
						path: 'shop_rank',
						name: 'shop_rank',
						component: () => import('@/views/table/shop_rank.vue'),
						meta: {
							title: '数据排行',
							auth: true
						}
					},
					{
						path: 'money_rank',
						name: 'money_rank',
						component: () => import('@/views/table/money_rank.vue'),
						meta: {
							title: '数据排行',
							auth: true
						}
					}
				]
			},
			{
				path: 'order',
				name: 'order',
				component: pageLayout,
				redirect: 'order/index',
				meta: {
					title: '订单',
					auth: true
				},
				children: [{
					path: 'index',
					name: 'order_index',
					component: () => import('@/views/order/order.vue'),
					meta: {
						title: '订单',
						auth: true
					}
				}, 
				{
					path: 'detail',
					name: 'order_detail',
					component: () => import('@/views/order/detail/order_detail.vue'),
					meta: {
						title: '订单详情',
						auth: true
					}
				},
				{
					path: 'aftersale_detail',
					name: 'aftersale_detail',
					component: () => import('@/views/order/detail/aftersale_detail.vue'),
					meta: {
						title: '退款/售后',
						auth: true
					}
				}]
			},
			{
				path: 'brand_fixtures',
				name: 'brand_fixtures',
				component: pageLayout,
				redirect: 'brand_fixtures/index',
				meta: {
					title: '企业装修',
					auth: true
				},
				children: [{
					path: 'index',
					name: 'brand_fixtures',
					component: () => import('@/views/brand_fixtures/brand_fixtures.vue'),
					meta: {
						auth: true
					},
				}]
			},
			{
				path: 'ent_dynamic',
				name: 'ent_dynamic',
				component: pageLayout,
				redirect: 'ent_dynamic/index',
				meta: {
					title: '企业动态',
					auth: true
				},
				children: [{
					path: 'index',
					name: 'ent_dynamic',
					component: () => import('@/views/brand_fixtures/ent_dynamic'),
					meta: {
						auth: true
					},
				}]
			},
			{
				path: 'shopindex',
				name: 'shopindex',
				component: pageLayout,
				redirect: 'shopindex/index',
				meta: {
					title: '信息发布',
					auth: true
				},
				children: [{
					path: 'index',
					name: 'shopindex',
					component: () => import('@/views/shop/shop'),
					meta: {
						auth: true
					},
				}]
			},
			{
				path: 'release_info',
				name: 'release_info',
				component: pageLayout,
				redirect: 'release_info/index',
				meta: {
					title: '信息发布',
					auth: true
				},
				children: [{
					path: 'index',
					name: 'release_info',
					component: () => import('@/views/Home/release_info'),
					meta: {
						auth: true
					},
				}]
			},
			{
				path: 'staff',
				name: 'staff',
				component: pageLayout,
				redirect: 'staff/index',
				meta: {
					title: '企业员工',
					auth: true
				},
				children: [{
					path: 'index',
					name: 'staff',
					component: () => import('@/views/staff/index.vue'),
					meta: {
						auth: true
					},
				},{
					path: 'addCard',
					name: 'addCard',
					component: () => import('@/views/staff/addCard.vue'),
					meta: {
						title: '添加企业员工',
						auth: true
					},
				}]
			},
			{
				path: 'upload_data',
				name: 'upload_data',
				component: pageLayout,
				redirect: 'upload_data/index',
				meta: {
					title: '企业资料',
					auth: true
				},
				children: [{
					path: 'index',
					name: 'upload_data',
					component: () => import('@/views/upload_data/index.vue'),
					meta: {
						auth: true
					},
				}]
			},
			{
				path: 'cooperation',
				name: 'cooperation',
				component: pageLayout,
				redirect: 'cooperation/index',
				meta: {
					title: '合作伙伴',
					auth: true
				},
				children: [{
					path: 'index',
					name: 'cooperation',
					component: () => import('@/views/cooperation/index.vue'),
					meta: {
						auth: true
					},
				}]
			},
			{
				path: 'business_card',
				name: 'business_card',
				component: pageLayout,
				redirect: 'business_card/index',
				meta: {
					title: '企业名片',
					auth: true
				},
				children: [{
					path: 'index',
					name: 'business_card',
					component: () => import('@/views/Home/business_card.vue'),
					meta: {
						auth: true
					},
				}]
			},
			{
				path: 'notice',
				name: 'notice',
				component: pageLayout,
				redirect: 'notice/index',
				meta: {
					title: '活动通告',
					auth: true
				},
				children: [{
					path: 'index',
					name: 'notice_index',
					component: () => import('@/views/notice/notice.vue'),
					meta: {
						auth: true
					},
				}]
			},
			{
				path: 'authority',
				name: 'authority',
				component: pageLayout,
				redirect: 'authority/index',
				meta: {
					title: '权限',
					auth: true
				},
				children: [{
						path: 'index',
						name: 'authority_index',
						component: () => import('@/views/authority/authority.vue'),
						meta: {
							auth: true
						},
					},
					{
						path: 'add',
						name: 'authority_add',
						component: () => import('@/views/authority/add.vue'),
						meta: {
							title: '添加管理员',
							auth: true
						},
					},
					{
						path: 'edit',
						name: 'authority_edit',
						component: () => import('@/views/authority/edit.vue'),
						meta: {
							title: '编辑管理员',
							auth: true
						},
					}
				]
			},
			{
				path: 'enterprise_info',
				name: 'enterprise_info',
				component: pageLayout,
				redirect: 'enterprise_info/index',
				meta: {
					title: '企业信息',
					auth: true
				},
				children: [{
						path: 'index',
						name: 'enterprise_info_index',
						component: () => import('@/views/enterprise_info/index.vue'),
						meta: {
							auth: true
						},
					}
				]
			},
			{
				path: 'modular_admin',
				name: 'modular_admin',
				component: pageLayout,
				redirect: 'modular_admin/index',
				meta: {
					title: '模块管理',
					auth: true
				},
				children: [{
					path: 'index',
					name: 'modular_admin',
					component: () => import('@/views/Home/modular_admin.vue'),
					meta: {
						auth: true
					},
				},{
					path: 'constitution',
					name: 'constitution',
					component: () => import('@/views/Home/constitution.vue'),
					meta: {
						title: '添加内容',
						auth: true
					},
				}]
			}
		]
	}
]

const router = new VueRouter({
	mode: 'hash',
	base: '/',
	routes
})
router.beforeEach(async (to, from, next) => {
	if (to.matched.some(record => record.meta.auth) && to.meta.auth) { // 判断该路由是否需要登录权限
		let token = localStorage.getItem('token');
		if (token) { // 获取当前的 token 是否存在
			next()
		} else {
			// 不存在 token，需要重新认证
			next({
				path: '/Login',
				query: {
					redirect: to.fullPath
				}
			})
		}
	}
	next()
})
export default router
